import _ from 'lodash';
import { axiosInstance } from '../helpers/axios';
import { userService } from './user.service';

export const designService = {
  create,
  find,
  update,
  findAll,
  export: _export,
  delete: _delete,
  duplicate,
};

function create(userId, design) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: design,
  };

  return axiosInstance
    .post(`/users/${userId}/designs`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function find(userId, designId) {
  const url = userId ? `/users/${userId}/designs/${designId}` : `/designs/${designId}`;
  return axiosInstance
    .get(url)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
}

function update(userId, design) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: design,
  };

  const url = userId ? `/users/${userId}/designs/${design.id}` : `/designs/${design.id}`;
  return axiosInstance
    .put(url, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function findAll(userId, query) {
  const url = userId ? `/users/${userId}/designs` : '/designs';
  return axiosInstance
    .get(url, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function _export(userId, designId, data, query) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', params: query },
    body: data,
  };

  const url = userId
    ? `/users/${userId}/designs/${designId}/export`
    : `/designs/${designId}/export`;
  return axiosInstance
    .post(url, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
}

function _delete(userId, designId) {
  return axiosInstance
    .delete(`/users/${userId}/designs/${designId}`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function duplicate(userId, designId) {
  return axiosInstance
    .post(`/users/${userId}/designs/${designId}/duplicate`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

const handleResponse = response => {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      userService.logout().then(() => window.location.reload(true));
    }

    const error = (data && data.message) || response.statusText;
    const name = data && data.name;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error, name };
  }

  return data;
};
